<template>
  <main>
    <PageHeader page-title="Invite friend" />
    <Header title="Your booking history" level="h4">Invite friend</Header>

    <p class="explain">
      Let your friend scan this QR code to get access to this App and your booking.
      Please be carefull whom you share it with
    </p>

    <img v-if="qr" :src="qr" alt="">

    <PageFooter />
  </main>
</template>

<script>
import dummyData from '@/dummy/my-account.json'

import PageHeader from '@/sections/page-header/PageHeader.vue'
import FormGenerator from '@/components/form/FormGenerator.vue'
import MeService from '@/services/MeService'
import PageFooter from '@/components/page-footer/PageFooter'


// TODO: Get form data and post it to the backend for pre-check-in

export default {
  components: {
    PageHeader,
    FormGenerator,
    PageFooter,
  },
  data () {
    return {
      qr: undefined,
      url: undefined
    }
  },
  methods: {
    getFriedQR() {
      MeService.getFriendQR().then(response => {
        this.qr = response.data.qr
        this.url = response.data.url
      })
    }
  },
  mounted () {
    this.getFriedQR()
  },
}
</script>
<style lang="scss">
.explain {
  font-size: 0.875rem;
  letter-spacing: 0.11px;
  line-height: 1.25rem;
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
